// extracted by mini-css-extract-plugin
module.exports = {"container":"Processing_container__2CmnD","title":"Processing_title__1h915"};